import React from "react";
import "./Ivora.scss";
import data from "./data.json";
import Card from "../../Component/Card/card";
import Ivora7images from "../../media/fasad/Ivora Grande/Ivora Grande 7/Ivora7";
import Ivora9images from "../../media/fasad/Ivora Grande/Ivora Grande 9/Ivora9";

const imageMap = {
  Ivora7images,
  Ivora9images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Ivora" className="produk">
      <h1>New Launching Summarecon Bandung</h1>
      <h2>Ivora Grande</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
